// extracted by mini-css-extract-plugin
export default {"bigSelectDropdown":"style--bigSelectDropdown--b3b054","bigOptions":"style--bigOptions--274c47"};